import React from 'react';

export default ({children}) => (<div className={''}>
    {children}
</div>);
